/**
 * 既存 params に送信 params を浅くマージし、送信側で値が `null` のキーは
 * 「明示的なクリア信号」として結果から削除する。
 *
 * 目的: `updateTestTarget` のような partial update では、キー省略は「変更しない」を
 * 意味するため、キー削除意図を伝える手段が別に必要になる。`null` を明示クリア信号と
 * して解釈することで、FE から「このキーを削除したい」意図を API に伝えられる。
 *
 * 典型ユースケース: マスク種別を「なし」にしたとき、FE が `{ maskType: null,
 * maskTags: null }` を送る。本関数が merge 後にそれらを削除し、保存 JSON から
 * maskType/maskTags が消える。
 */
export function mergeParamsWithClearSignal(
  existing: Record<string, unknown>,
  incoming: Record<string, unknown>
): Record<string, unknown> {
  const merged: Record<string, unknown> = { ...existing, ...incoming };
  for (const [k, v] of Object.entries(incoming)) {
    if (v === null) {
      delete merged[k];
    }
  }
  return merged;
}
